import { useCallback } from "react";

import {
  useRequestWithFeedback,
  type OverrideRunProps,
} from "../../../composites";

import { API } from "./api";

import type {
  DirectDepositManualForm,
  DirectDepositSSOResponse,
  ManualEnrollmentDocumentResponse,
} from "./types";

export const useGetDirectDepositSSOToken = () => {
  const { send } = useRequestWithFeedback<DirectDepositSSOResponse>();

  const fetchSSOToken = useCallback(
    (overrideRunProps?: OverrideRunProps<DirectDepositSSOResponse>) => {
      send({
        action: API.getSSOToken(),
        ...overrideRunProps,
      });
    },
    [send],
  );

  return { fetchSSOToken };
};

export const useGetDirectDepositManualEnrollmentDocument = () => {
  const { send, loading } =
    useRequestWithFeedback<ManualEnrollmentDocumentResponse>();

  const fetchManualEnrollmentDocument = useCallback(
    (
      formData: DirectDepositManualForm,
      overrideRunProps?: OverrideRunProps<ManualEnrollmentDocumentResponse>,
    ) => {
      send({
        action: API.getManualEnrollmentDocument(formData),
        ...overrideRunProps,
      });
    },
    [send],
  );

  return { fetchManualEnrollmentDocument, loading };
};
